import { defineMessages } from '@/hooks/useTranslation';

export default defineMessages({
  hero: {
    title: {
      de: 'Über uns',
      en: 'About us'
    },
    subtitle: {
      de: 'splusd solutions',
      en: 'splusd solutions'
    },
    description: {
      de: 'Wir sind Ihr Partner für kundenorientierte Business Software und IT-Lösungen',
      en: 'We are your partner for customer-oriented business software and IT solutions'
    },
    details: {
      de: 'Als erfahrenes Team entwickeln wir maßgeschneiderte Lösungen, die Ihre Geschäftsprozesse optimieren und Ihren Erfolg fördern.',
      en: 'As an experienced team, we develop customized solutions that optimize your business processes and promote your success.'
    },
    primaryCTA: {
      de: 'Kontakt aufnehmen',
      en: 'Contact us'
    },
    secondaryCTA: {
      de: 'Projekte ansehen',
      en: 'View projects'
    }
  },
  content: {
    title: {
      de: 'Über Uns',
      en: 'About Us'
    },
    subtitle: {
      de: 'Gemeinsam erfolgreich mit Transparenz, Struktur und Wissenstransfer. Wir arbeiten mit unseren Kunden, nicht nur für sie.',
      en: 'Successful together with transparency, structure and knowledge transfer. We work with our customers, not just for them.'
    },
    intro: {
      de: 'Denn nur wenn Fachexpertise auf Branchenerfahrung trifft, entstehen gute Produkte und hervorragende Lösungen.',
      en: 'Because only when expertise meets industry experience do good products and excellent solutions emerge.'
    },
    cards: {
      first: {
        title: {
          de: 'Strukturierte & planbare Umsetzung',
          en: 'Structured & plannable implementation'
        },
        description: {
          de: 'Wir legen großen Wert auf realistische Deadlines und Ergebnisse, die langfristig Bestand haben. Lieber eine Lösung, die nachhaltig funktioniert, als ein schnelles, aber halbgares Ergebnis.',
          en: 'We place great importance on realistic deadlines and results that last in the long term. Rather a solution that works sustainably than a quick but half-baked result.'
        }
      },
      second: {
        title: {
          de: 'Nachhaltige Beratung & Wissenstransfer',
          en: 'Sustainable consulting & knowledge transfer'
        },
        description: {
          de: 'Unser Ziel ist es, dass Lösungen auch ohne externe Abhängigkeiten langfristig funktionieren. Daher ist es uns wichtig, dass Ansprechpartner geschult werden und Wissen im Unternehmen bleibt.',
          en: 'Our goal is for solutions to work in the long term even without external dependencies. That\'s why it\'s important to us that contacts are trained and knowledge remains in the company.'
        }
      },
      third: {
        title: {
          de: 'Flexibilität in der Zusammenarbeit',
          en: 'Flexibility in collaboration'
        },
        description: {
          de: 'Jedes Unternehmen hat unterschiedliche Anforderungen – manche brauchen eine komplette Umsetzung, andere wollen selbst lernen und nur gelegentliche Unterstützung. Genau darauf sind unsere Leistungen ausgerichtet.',
          en: 'Each company has different requirements - some need complete implementation, others want to learn themselves and only occasional support. Our services are geared precisely to this.'
        }
      }
    },
    mission: {
      first: {
        de: 'Wir haben unser Unternehmen gegründet, weil wir überzeugt sind, dass erfolgreiche digitale Lösungen nur mit kollaborativer, transparenter und nachhaltiger Arbeit entstehen.',
        en: 'We founded our company because we are convinced that successful digital solutions can only be created with collaborative, transparent and sustainable work.'
      },
      second: {
        de: 'Unser Ziel ist es nicht nur, funktionierende Software oder Automatisierungslösungen zu liefern, sondern echte Veränderungen in Unternehmen zu ermöglichen – durch die richtige Technologie, eine klare Strategie und ein starkes Miteinander.',
        en: 'Our goal is not only to deliver functioning software or automation solutions, but to enable real changes in companies - through the right technology, a clear strategy and a strong togetherness.'
      }
    }
  },
  serviceModels: {
    title: {
      de: 'Unsere Leistungsmodelle',
      en: 'Our service models'
    },
    first: {
      title: {
        de: '„We Build It" – Wir setzen es für euch um',
        en: '"We Build It" – We implement it for you'
      },
      description: {
        de: 'Ihr braucht eine fertige Lösung, ohne euch um technische Details kümmern zu müssen? Wir übernehmen die gesamte Umsetzung – von der Strategie bis zur technischen Realisierung.',
        en: 'You need a complete solution without having to worry about technical details? We take care of the entire implementation - from strategy to technical realization.'
      },
      ideal: {
        de: 'Ideal für Unternehmen, die schnell eine Lösung brauchen, aber selbst keine internen Ressourcen haben.',
        en: 'Ideal for companies that need a solution quickly but don\'t have internal resources themselves.'
      }
    },
    second: {
      title: {
        de: '„We Empower You" – Enablement & Sparring',
        en: '"We Empower You" – Enablement & Sparring'
      },
      description: {
        de: 'Euer Team möchte selbst an der Umsetzung arbeiten, aber es fehlt die Orientierung? Wir stehen euch als Sparringspartner zur Seite, geben Wissen, Best Practices und klare Strategien weiter, damit ihr langfristig unabhängig arbeitet.',
        en: 'Your team wants to work on the implementation themselves, but lacks orientation? We are at your side as a sparring partner, pass on knowledge, best practices and clear strategies so that you work independently in the long term.'
      },
      ideal: {
        de: 'Ideal für Unternehmen, die intern Kompetenzen aufbauen und sich strategisch weiterentwickeln möchten.',
        en: 'Ideal for companies that want to build up competencies internally and develop strategically.'
      }
    }
  }
}); 